import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextFieldAdapter from 'components/shared/TextFieldAdapter';
import DialogLoadingIndicator from 'components/shared/DialogLoadingIndicator';
import SectionTitle from 'components/layout/SectionTitle';
import { supplierActions } from 'store/modules/supplier';
import { uiActions } from 'store/modules/ui';
import routes from 'common/routes';
import { validateSupplier } from 'common/formValidations';
import { getFieldsToUpdate } from 'common/utils';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  submit: {
    textAlign: 'right',
  },
  cancel: {
    marginRight: theme.spacing(2),
  },
}));

const UpdateSupplier = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const { id } = useParams();

  const [initialValues, setInitialValues] = useState({});

  const {
    suppliers,
    loading,
  } = useSelector((state) => ({
    suppliers: state.supplier.suppliers,
    loading: state.supplier.loading.list,
  }));

  const getValues = () => {
    if (suppliers && suppliers.length > 0) {
      const supplier = suppliers.find((element) => element.id === id);

      if (supplier) {
        setInitialValues({
          id: supplier.id,
          nit: supplier.nit,
          name: supplier.name,
          manager: supplier.manager,
          address: supplier.address,
          city: supplier.city,
          phone: supplier.phone,
          fax: supplier.fax,
          email: supplier.email,
        });
      } else {
        history.goBack();
      }
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    dispatch(uiActions.updatePageTitle(routes.supplier.update.title));
  }, [dispatch]);

  useEffect(getValues, [suppliers]);

  const onSubmit = (values) => {
    const input = getFieldsToUpdate(values, initialValues);
    dispatch(supplierActions.updateSupplier({ id: values.id, input }));
  };

  return (
    <React.Fragment>
      <SectionTitle text="Crear Proveedor" backButton />
      <Paper square className={classes.paper}>
        <Form
          initialValues={initialValues}
          validate={validateSupplier}
          onSubmit={onSubmit}
          render={({
            handleSubmit,
            invalid,
            pristine,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogLoadingIndicator open={loading} />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="name"
                    component={TextFieldAdapter}
                    label="Nombre"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="nit"
                    component={TextFieldAdapter}
                    label="NIT"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="manager"
                    component={TextFieldAdapter}
                    label="Manager"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="address"
                    component={TextFieldAdapter}
                    label="Dirección"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="city"
                    component={TextFieldAdapter}
                    label="Ciudad"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="email"
                    component={TextFieldAdapter}
                    label="Email"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="phone"
                    component={TextFieldAdapter}
                    label="Teléfono"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Field
                    name="fax"
                    component={TextFieldAdapter}
                    label="Fax"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <Button
                    className={classes.cancel}
                    type="button"
                    color="secondary"
                    component={RouterLink}
                    to={routes.supplier.index.path}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.submit}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={invalid || pristine || loading}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        />
      </Paper>
    </React.Fragment>
  );
};

export default UpdateSupplier;
